class Module {
  constructor (options) {
    this.options = options;
    this.init = this.init.bind(this);
  }

  init () {
    //console.log('Components Init')
  }

  destroy () {}

  onResize () {}
}

export default Module
